import { ScoopText, ScoopCenter, ScoopColumn } from '../../../../ui'
import { ImageBrokenIcon } from '@phosphor-icons/react'
import styles from './ProcessError.module.scss'

export const ProcessError = ({ diagramName }) => {
    return (
        <ScoopCenter className={styles.container}>
            <ScoopColumn className={styles.content}>
                <ImageBrokenIcon size={60} weight="regular" className={styles.icon} />
                <ScoopText className={styles.title}>Unable to render diagram</ScoopText>
                <ScoopColumn className={styles.messageGroup}>
                    <ScoopText className={styles.message}>
                        The current configuration produced an error.
                    </ScoopText>
                    <ScoopText className={styles.message}>Please try:</ScoopText>
                    <ScoopColumn className={styles.suggestionsList}>
                        <ScoopText className={styles.suggestion}>
                            • Adjusting your filters or date range
                        </ScoopText>
                        <ScoopText className={styles.suggestion}>
                            • Selecting different values
                        </ScoopText>
                        <ScoopText className={styles.suggestion}>
                            • Changing the step configuration
                        </ScoopText>
                    </ScoopColumn>
                    {diagramName && (
                        <ScoopText className={styles.preservedMessage}>
                            Your panel settings have been preserved.
                        </ScoopText>
                    )}
                </ScoopColumn>
            </ScoopColumn>
        </ScoopCenter>
    )
}
